import styled from 'styled-components';

export const Wrapper = styled.div`
  display: contents;
  text-align: center;
  .root {
    text-align: center;
    padding-top: 20px;
    padding-bottom: 100px;
    width: 100%;
    max-width: 66%;
    @media (max-width: 767px) {
      max-width: 100%;
      padding-inline: 16px;
    }
  }

  .forgotPassword {
    //color: var(--color-link);
    margin: 0 0 50px;
    font-size: 18px;

    line-height: 22px;
    font-weight: 600;
  }
  .noWorries {
    text-align: center;
    margin: 0 0 30px;
    color: var(--color-text-muted);

    line-height: 12px;
    font-size: 12px;
    font-weight: 600;
  }
  .form {
    text-align: initial;
  }
  .content {
    margin: auto;
  }
  .backToLogin {
    display: block;
    text-align: center;

    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 12px;
    text-decoration: underline;
    color: var(--color-link);
    margin: 0 0 30px;
    &:hover {
      color: var(--color-link);
      text-decoration: none;
    }
  }
  .dontHaveAnAccount {
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 12px;
    //color: var(--color-link);
    text-align: center;
    margin: 0 0 30px;
  }
  .signUp {
    color: var(--color-link);
    cursor: pointer;
    text-decoration: underline;
    &:hover {
      text-decoration: none;
    }
  }
  .formError {
    margin-bottom: 30px;
  }
  .checkEmailIcon {
    margin: 0 0 30px;
  }
  .completePlease {
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    text-align: center;
    text-transform: capitalize;
    color: var(--color-link);
    margin: 0 0 30px;
  }
  .completeWeSent {
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    color: var(--color-text-muted);
    margin: 0 0 30px;
  }
  .completeDidnt {
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 12px;
    color: var(--color-link);
  }
  .completeResend {
    cursor: pointer;
    text-decoration: underline;
    color: var(--color-link);
  }
`;
